import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { APP_CONSTANTS } from '@pendwa/common/utils/constants.js';
import { captureException } from '@sentry/browser';
import clsx from 'clsx';
import React from 'react';
import { ContextPageData, EnumDisplayLanguage } from '../../../context/PageData/index.js';
import { appStore } from '../../../core/appStore/index.js';
export const ChooseDisplayLanguageDuo = () => {
    const { display_language, setDisplayLanguage } = React.useContext(ContextPageData);
    const renderOption = (name, code, index) => {
        if (display_language === code) {
            return (_jsx("span", { className: clsx('rounded-full bg-indigo-500 px-3 py-0.5 text-center text-xs font-semibold uppercase leading-5 tracking-wide text-white', {
                    'mr-4': index === 0,
                    'ml-4': index === 1,
                }), children: name }));
        }
        else {
            return (_jsx("span", { className: clsx('px-3 py-0.5 text-center text-sm', {
                    'mr-4': index === 0,
                    'ml-4': index === 1,
                }), onClick: () => {
                    try {
                        appStore.set(APP_CONSTANTS.CHOOSE_DISPLAY_LANGUAGE_DUO_STORAGE_KEY, code);
                    }
                    catch (error) {
                        captureException(error);
                    }
                    setDisplayLanguage(code);
                }, children: name }));
        }
    };
    return (_jsxs("a", { href: "#", className: "inline-flex items-center rounded-full bg-gray-900 p-1 pr-2 text-white hover:text-gray-200 sm:text-base lg:text-sm xl:text-base", children: [renderOption('English', EnumDisplayLanguage.english, 0), renderOption('Kiswahili', EnumDisplayLanguage.swahili, 1)] }));
};
//# sourceMappingURL=index.js.map